import styles from "./styles.module.scss";

import { IconCard } from "../../../../shared";

import { useState } from "react";
import { Button } from "../../../../../../common";
import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";

const data = [
  {
    value: "Improved physique",
    displayValue: "Improved physique"
  },
  {
    value: "Energy boost",
    displayValue: "Energy boost"
  },
  {
    value: "Heart health",
    displayValue: "Heart health"
  },
  {
    value: "Sleep better",
    displayValue: "Sleep better"
  },
  {
    value: "Stress Reduction",
    displayValue: "Stress Reduction"
  },
  {
    value: "Better shape",
    displayValue: "Better shape"
  },
  {
    value: "Increase life expectancy",
    displayValue: "Increase life expectancy"
  },
  {
    value: "Fat Burn",
    displayValue: "Fat Burn"
  },
  {
    value: "Better mobility",
    displayValue: "Better mobility"
  }
];
export const ChooseFocus = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (v) => {
    const { value } = v;
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }
      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    onNextStep?.(checked);
    onTrackEvent?.(checked);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Choose your focus</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              active={checked.includes(value.value)}
              onClick={() => handleCheck(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.value}
            />
          ))}
        </div>
      </div>
      <div className={styles.action}>
        <Button variant='walky' disabled={!checked.length} onClick={handleNextStep}>
          Continue
        </Button>
      </div>
    </div>
  );
};
